var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MfaCodeAuthentication',{attrs:{"method":"sms","auto-send":_vm.autoSend}})}
var staticRenderFns = []

export { render, staticRenderFns }